import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Popover, Modal, message, notification, Switch } from "antd";
import { DragDropContext } from "react-beautiful-dnd";
import { range, findIndex, forEach, round, omit, find, sumBy, values, chain, cloneDeep, debounce } from "lodash";
import { ReactSVG } from "react-svg";
import moment from "moment";
import socketIOClient from "socket.io-client";
import { useDispatch, useSelector } from "react-redux";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { DownOutlined, UpOutlined, ZoomInOutlined, ZoomOutOutlined } from "@ant-design/icons";

import "./index.scss";
import UnScheduled from "./UnScheduled";
import DriverTime from "./DriverTime";
import DriverList from "./DriverList";
import SwapDriver from "./SwapDriver";
import {
  getStopsHash,
  getFirstStartAndLastEnd,
  calculatePixelBetweenStops,
  getActionDnd,
  getActiveAction,
  isDiffTwoArrayStops,
  getDriverIds,
  convertPixelToMinutes,
  convertMinutesToPixel,
} from "./Utils";

import {
  doDetailRoutePlan,
  doDetailRoutePlanNoFetching,
  doSwapOrdersToDriver,
  doUpdateIsLive,
} from "../../modules/routePlan/stores/thunk";
import { STATUS, ONE_HOUR_PX } from "../../constants";

import { convertMinutesToTime, getTranslation } from "../../utils/helper";
import { hhMmToHours } from "../../utils/eta";

import { doUpdateSettingNoFetching } from "../../modules/setting/stores/thunk";
import SwapStopsToDriver from "./SwapStopsToDriver";
import { doGetTokenRoutePlanLabel } from "../../modules/routePlan/api";

const socketURI = process.env.REACT_APP_SOCKET_URI || "";
const socket = socketIOClient(socketURI);
const initMultipleSteps = {
  toDriverId: undefined,
  index: undefined,
  steps: [],
  visibleModal: false,
  searchedRoutes: [],
  selectedRoute: undefined,
  index: undefined,
};

const initStateTimeline = {
  minTimePx: null,
  maxTimePx: null,
  maxTimeMinutes: null,
  minTimeMinutes: null,
};

const RouteChart = ({
  routePlan,
  routes,
  stops,
  onClickStop,
  onClickRoute,
  stepsHovered,
  setStepsHovered,
  clicked,
  setClicked,
  driverIdsHide,
  setDriverIdsHide,
  doOptimizeRoutePlan,
  doReorderRoute,
  doDispatchRoutePlan,
  doLockDriver,
  onClosePopup,
  routeType,
  setRouteType,
  setChartType,
  setShowMoreRoute,
  setting,
  driverIdsLock,
  setDriverIdsLock,
  chartRef,
  stepClicked,
  isOptimize,
  setIsOptimize,
}) => {
  const [isSolution, setIsSolution] = useState(false);
  const [solutions, setSolutions] = useState({});
  const [formatRoutes, setFormatRoutes] = useState({});
  const [startTime, setStartTime] = useState(8);
  const [hourStart, setHourStart] = useState(8);
  const [hourEnd, setHourEnd] = useState(8);
  const [isDragging, setIsDragging] = useState(false);
  const [isLive, setIsLive] = useState(true);
  const [expand, setExpand] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [orderMess, setOrderMess] = useState(null);

  const [actionDnd, setActionDnd] = useState("none");
  const [indexFormat, setIndexFormat] = useState(0);

  const [history, setHistory] = useState({
    currentIndex: 0,
    listSolutions: [],
  });

  const [state, setState] = useState({
    visibleModal: false,
    searchedRoutes: [],
    swapFromRoute: {},
    swapToRoute: {},
  });

  const [isGmpro, setIsGmpro] = useState(false);

  const [stateTimeLine, setStateTimeLine] = useState(initStateTimeline);

  const containerTimelineRef = useRef(null);
  const nonTimeRef = useRef(null);
  const timeLineRef = useRef(null);

  const [multipleStepState, setMultipleStepState] = useState(initMultipleSteps);

  const dispatch = useDispatch();
  const { user } = useSelector(state => state.auth);
  const canEdit = !user?.roles?.includes("user");
  const orderIds = stops.map(s => s.orderId);

  const stopsHash = getStopsHash(stops);

  const defaultOneHourPx = setting.defaultOneHourPx || ONE_HOUR_PX;
  const [oneHourPx, setOneHourPx] = useState(defaultOneHourPx);

  const handleReset = () => {
    setOneHourPx(defaultOneHourPx);
  };
  const handleSaveZoom = () => {
    dispatch(doUpdateSettingNoFetching({ defaultOneHourPx: oneHourPx }));
  };
  const handleZoomIn = () => {
    setOneHourPx(oneHourPx + oneHourPx / 10);
    const currentLeft = containerTimelineRef.current.scrollLeft;
    containerTimelineRef.current.scrollTo({
      left: currentLeft === 0 ? 0 : currentLeft + currentLeft / 10,
    });
  };
  const handleZoomOut = () => {
    setOneHourPx(oneHourPx - oneHourPx / 10);
    const currentLeft = containerTimelineRef.current.scrollLeft;
    containerTimelineRef.current.scrollTo({
      left: currentLeft === 0 ? 0 : currentLeft - currentLeft / 10,
    });
  };

  const handleKeyUp = event => {
    if (event.key === "Meta" || event.key === "Control" || event.key === "Shift") {
      if (multipleStepState.steps?.length > 0) {
        setMultipleStepState({
          ...multipleStepState,
          visibleModal: true,
        });
      }
    }
  };

  const clickTimeLine = number => {
    let newMinTimePx = stateTimeLine.minTimePx;
    let newMaxTimePx = stateTimeLine.maxTimePx;

    if (stateTimeLine.minTimePx && stateTimeLine.maxTimePx) {
      if (number > stateTimeLine.maxTimePx) {
        newMaxTimePx = number;
      } else {
        newMinTimePx = number;
      }
    } else if (!stateTimeLine.minTimePx) {
      newMinTimePx = number;
    } else {
      newMaxTimePx = number;
    }

    setStateTimeLine({
      minTimePx: newMinTimePx,
      maxTimePx: newMaxTimePx,
    });
  };

  const handleZoomByTime = () => {
    if (
      !nonTimeRef?.current ||
      !containerTimelineRef?.current ||
      !stateTimeLine.maxTimePx ||
      !stateTimeLine.minTimePx
    ) {
      return;
    }
    const { width: nonTimeWidth } = nonTimeRef.current.getBoundingClientRect();
    const { width: containerTimelineWidth } = containerTimelineRef.current.getBoundingClientRect();
    const fullScreenWidth = containerTimelineWidth - nonTimeWidth - 10;
    const widthSelected = stateTimeLine.maxTimePx - (stateTimeLine.minTimePx || 0);
    const scaleFactor = fullScreenWidth / widthSelected;
    const maxTimeMinutes = convertPixelToMinutes(stateTimeLine.maxTimePx, oneHourPx);
    const minTimeMinutes = convertPixelToMinutes(stateTimeLine.minTimePx, oneHourPx);
    setStateTimeLine({
      ...stateTimeLine,
      maxTimeMinutes,
      minTimeMinutes,
    });
    setOneHourPx(widthSelected * scaleFactor * (60 / (maxTimeMinutes - minTimeMinutes)) - 70);
  };

  const onOutsideClickTimeLine = () => {
    setStateTimeLine(initStateTimeline);
  };

  const handleClickOutside = e => {
    if (timeLineRef.current && !timeLineRef.current.contains(e.target)) {
      onOutsideClickTimeLine();
    }
  };

  useEffect(() => {
    setIsGmpro(setting?.isGmproEnabled && setting?.isGmproRoutePlanEnabled);
  }, [setting]);

  useEffect(() => {
    if (stateTimeLine.maxTimePx && stateTimeLine.minTimePx) {
      const timeout = setTimeout(() => {
        handleZoomByTime();
      }, 50);

      return () => clearTimeout(timeout);
    }
  }, [stateTimeLine.maxTimePx, stateTimeLine.minTimePx]);

  useEffect(() => {
    window.addEventListener("keyup", handleKeyUp);
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("keyup", handleKeyUp);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [multipleStepState, stateTimeLine]);

  const selectedMultipleSteps = (step, driverId) => {
    const cloneSteps = [...multipleStepState.steps];
    const typeBelong = step.type === "pickup" ? "delivery" : "pickup";
    const indexStep = cloneSteps.findIndex(
      s => s.orderId === step.orderId && s.type === step.type && s.driverId === driverId,
    );
    const indexStepBelong = cloneSteps.findIndex(
      s => s.orderId === step.orderId && s.type === typeBelong && s.driverId === driverId,
    );
    if (indexStep > -1) {
      cloneSteps.splice(indexStep, 1);
      if (indexStepBelong > -1) cloneSteps.splice(indexStepBelong, 1);
    } else {
      const stepBelong = solutions[driverId]?.find(s => {
        return s.orderId === step.orderId && s.type === typeBelong;
      });
      if (typeBelong === "pickup") {
        if (stepBelong) {
          cloneSteps.unshift({
            ...step,
            type: typeBelong,
            index: stepBelong.index,
            driverId,
          });
        }
        cloneSteps.unshift({ ...step, driverId });
      } else {
        cloneSteps.unshift({ ...step, driverId });
        if (stepBelong) {
          cloneSteps.unshift({
            ...step,
            type: typeBelong,
            index: stepBelong.index,
            driverId,
          });
        }
      }
    }
    setMultipleStepState({ ...multipleStepState, steps: cloneSteps });
  };

  const setAllInclusiveMultipleSteps = (newStep, driverId) => {
    // Clone the current steps array
    let clonedSteps = [...multipleStepState.steps];

    // Get the solutions data for the current driver
    const driverSolutions = solutions[driverId] || [];

    // If steps array is empty, add the new step
    if (clonedSteps.length === 0) {
      clonedSteps = [{ ...newStep, driverId }];
    } else {
      // Check if the first step in the array belongs to the same driver
      const firstStep = clonedSteps[0];
      if (firstStep.driverId !== driverId) {
        clonedSteps = [{ ...newStep, driverId }];
      } else {
        // Find the indices of the first step and the new step in the solutions data
        const firstStepIndex = driverSolutions.findIndex(
          s => s.orderId === firstStep.orderId && s.type === firstStep.type,
        );
        const newStepIndex = driverSolutions.findIndex(s => s.orderId === newStep.orderId && s.type === newStep.type);

        // If either index is not found, return
        if (firstStepIndex === -1 || newStepIndex === -1) return;

        // Determine the maximum and minimum indices
        const maxIndex = Math.max(firstStepIndex, newStepIndex);
        const minIndex = Math.min(firstStepIndex, newStepIndex);

        // Iterate over the solutions data
        driverSolutions.forEach((solutionStep, i) => {
          // Check if the current solution step is within the range of indices
          if (i >= minIndex && i <= maxIndex) {
            // Determine the type of the step (pickup or delivery)
            const counterpartType = solutionStep.type === "pickup" ? "delivery" : "pickup";

            // Find the index of the current solution step and its counterpart in the steps array
            const stepIndex = clonedSteps.findIndex(
              s => s.orderId === solutionStep.orderId && s.type === solutionStep.type && s.driverId === driverId,
            );
            const counterpartIndex = clonedSteps.findIndex(
              s => s.orderId === solutionStep.orderId && s.type === counterpartType && s.driverId === driverId,
            );

            // If the current solution step is not already in the steps array, add it
            if (stepIndex === -1) {
              clonedSteps.unshift({ ...solutionStep, driverId });
            }

            // If the counterpart of the current solution step is not already in the steps array, add it
            if (counterpartIndex === -1) {
              const counterpartStep = driverSolutions.find(
                s => s.orderId === solutionStep.orderId && s.type === counterpartType,
              );
              if (counterpartStep) {
                clonedSteps.unshift({
                  ...solutionStep,
                  type: counterpartType,
                  index: counterpartStep.index,
                  driverId,
                });
              }
            }
          }
        });
      }
    }

    // Set the updated steps array in the state
    setMultipleStepState({ ...multipleStepState, steps: clonedSteps });
  };

  useEffect(() => {
    if (routes?.length) {
      const [startAt, endAt] = getFirstStartAndLastEnd(routes);
      const startHour = startAt && startAt?.split(":")[0];
      setHourStart(Number(startHour));
      const endHour = endAt && endAt?.split(":")[0];
      setHourEnd(Number(endHour));
      const startHourFull = `${startHour}:00`;
      setStartTime(startHourFull);

      formatSolutions(routes, stops, Number(startHour), Number(endHour), startHourFull);

      if (stateTimeLine.maxTimePx || stateTimeLine.minTimePx) {
        if (stateTimeLine.minTimeMinutes) {
          const pxScroll = convertMinutesToPixel(stateTimeLine.minTimeMinutes, oneHourPx);
          containerTimelineRef.current.scrollTo({
            left: pxScroll - 80,
          });
        }
        setStateTimeLine(initStateTimeline);
      }
    }
  }, [routePlan, oneHourPx]);

  useEffect(() => {
    const driverIdsLock = routes.filter(r => r.locked).map(r => r.driver._id);
    if (driverIdsLock?.length === routes?.length) driverIdsLock.push("all-drivers");
    setDriverIdsLock(driverIdsLock);
  }, [routes]);

  useEffect(() => {
    setIsLive(routePlan.isLive || false);
  }, [routePlan]);

  useEffect(() => {
    setActionDnd(getActionDnd(history, solutions, indexFormat));
  }, [history]);

  useEffect(() => {
    socket.connect();
    socket.off(user.company?._id).on(user.company?._id, data => {
      if (data.event === "order.changing.status" && orderIds.includes(data.payload.orderId)) {
        const orderCode = stops.find(s => s.orderId === data.payload.orderId)?.orderCode;
        const mess = `Order ${orderCode} has been updated to ${STATUS.find(s => s.code === data.payload.status)?.name}`;
        setOrderMess(mess);
        if (history.currentIndex !== 0) {
          setIsModalVisible(true);
        } else {
          message.info(mess);
          dispatch(doDetailRoutePlanNoFetching(routePlan._id));
        }
      }
    });
    return () => {
      socket.disconnect();
    };
  }, [history]);

  const handleOptimizeForce = () => {
    doOptimizeRoutePlan({
      id: routePlan._id,
      forceAll: true,
      applyBalanceSetting: true,
    });
    onClosePopup();
  };

  const handleOptimize = () => {
    if (isLive) return;
    const assigns = {};
    routes.map(route => {
      solutions[`assign_${route.driver._id}`].map(step => {
        assigns[step.orderId] = route.driver._id;
      });
    });
    solutions["unscheduled"].map(step => {
      assigns[step.orderId] = "UNLOCKED";
    });
    doOptimizeRoutePlan({
      id: routePlan._id,
      assigns,
      forceAll: false,
      applyBalanceSetting: true,
    });
    setIsOptimize(true);
    onClosePopup();
  };

  const handleReorder = () => {
    if (isLive) return;
    const drivers = [];
    const originSolutions = history.listSolutions[indexFormat];
    const orders = routePlan.orders;
    routes.map(route => {
      const isDiff = isDiffTwoArrayStops(solutions[route.driver._id], originSolutions[route.driver._id]);
      if (isDiff) {
        const driver = { driverId: route.driver._id, order: [] };
        solutions[route.driver._id].map(step => {
          const order = orders.find(order => order._id === step.orderId);

          if (
            order &&
            order.status != "SKIPPED" &&
            ((step.type.toUpperCase() === "PICKUP" && order.pickupStatus != "COLLECTED") ||
              (step.type.toUpperCase() === "DELIVERY" && order.status != "COMPLETED"))
          ) {
            driver.order.push(`${step.orderId}_${step.type.toUpperCase()}`);
          }
        });
        drivers.push(driver);
      }
    });
    doReorderRoute({ id: routePlan._id, drivers });
    onClosePopup();
  };

  useEffect(() => {
    if (actionDnd === "sort") {
      handleReorder();
    }
  }, [actionDnd]);

  const handleDispatch = async () => {
    if (isLive) return;
    try {
      await doDispatchRoutePlan({
        id: routePlan._id,
        type: "SEND_NOW",
        sendAt: moment().toISOString(),
      });
      onClosePopup();
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(doDetailRoutePlan(routePlan._id));
    }
  };

  const onClickStep = (orderId, type) => {
    setClicked(true);
    onClickStop(stopsHash[`${orderId}-${type}`]);
  };

  const handleKeyDown = useCallback(
    debounce(
      event => {
        const isHasStepClicked = Object.keys(stepsHovered)?.find(k => stepsHovered[k]);
        if (!isHasStepClicked) return;

        if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
          event.preventDefault();
          const route = routes.find(r => r.driver._id === stepClicked?.driverId);
          const steps = route.steps.filter(s => s.type.toLowerCase() != "driver");

          if (steps.length > 0) {
            const index = steps.findIndex(
              s => s.orderId === stepClicked?.orderId && s.type.toLowerCase() === stepClicked?.type.toLowerCase(),
            );
            let newStep = steps[index + (event.key === "ArrowRight" ? 1 : -1)];
            if (index === -1) return;

            if (index === steps.length - 1 && event.key === "ArrowRight") {
              newStep = steps[0];
            } else if (index === 0 && event.key === "ArrowLeft") {
              newStep = steps[steps.length - 1];
            }

            if (newStep) {
              onClickStep(newStep.orderId, newStep.type.toLowerCase());
            }
          }
        }
      },
      200,
      { leading: true },
    ),
    [stepClicked, stepsHovered, routes, onClickStep, oneHourPx],
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      handleKeyDown.cancel(); // Cancel any pending debounced calls
    };
  }, [oneHourPx, stepClicked, stepsHovered, handleKeyDown]);

  // const onHoverStep = (orderId, type) => {
  //   return false
  //   // setClicked(true);
  //   // onClickStop(stopsHash[`${orderId}-${type}`]);
  // };
  const onHoverStep = () => {
    return false;
  };

  const handleOnClickRoute = (route, type) => {
    setClicked(true);
    setRouteType(type);
    onClickRoute(route);
  };

  const handleOnHoverRoute = (route, type) => {
    setClicked(false);
    setRouteType(type);
    onClickRoute(route);
  };

  const onClickLock = driverId => {
    const driverIds = getDriverIds(routes, driverIdsLock, driverId);
    setDriverIdsLock(driverIds);
    doLockDriver({
      id: routePlan._id,
      driver: driverId !== "all-drivers" ? driverId : undefined,
      locked: driverIds.includes(driverId),
    });
  };

  const onClickHide = driverId => {
    const driverIds = getDriverIds(routes, driverIdsHide, driverId);
    setDriverIdsHide(driverIds);
    onClickStop({ id: "closed" });
  };

  const onDragEnd = result => {
    setIsDragging(false);
    const { source, destination } = result;
    if (!destination) return;
    if (source.droppableId === destination.droppableId) {
      if (destination.index === source.index) return;

      const sourceClone = [...solutions[source.droppableId]];
      const stop = sourceClone[source.index];
      const type = stop.type === "pickup" ? "delivery" : "pickup";
      const stopLeftIndex = findIndex(sourceClone, s => s.orderId === stop.orderId && s.type === type);

      if (
        (type === "delivery" && destination.index >= stopLeftIndex) ||
        (type === "pickup" && destination.index <= stopLeftIndex)
      ) {
        notification.error({
          message: "The drop-off point must stay behind the pickup point and cannot be moved ahead of it.",
          placement: "bottomRight",
        });
        return;
      }

      const [removed] = sourceClone.splice(source.index, 1);
      sourceClone.splice(destination.index, 0, {
        ...removed,
        width: 24,
        marginLeft: 8,
      });
      const newSolutions = { ...solutions };
      newSolutions[source.droppableId] = sourceClone;

      setSolutions(newSolutions);
      setStepsHovered({});

      if (destination.droppableId.includes("assign")) return;
      if (destination.droppableId === "unscheduled") return;

      setHistory({
        currentIndex: history.currentIndex + 1,
        listSolutions: [...history.listSolutions, newSolutions],
      });
    } else {
      moveStep(source, destination);
    }
  };

  const moveStep = (droppableSource, droppableDestination) => {
    const sourceClone = [...solutions[droppableSource.droppableId]];
    const destClone = [...solutions[droppableDestination.droppableId]];
    const stop = sourceClone[droppableSource.index];

    const [removed] = sourceClone.splice(droppableSource.index, 1);
    destClone.splice(droppableDestination.index, 0, {
      ...removed,
      width: 24,
      marginLeft: 8,
    });

    const type = stop.type === "pickup" ? "delivery" : "pickup";
    const stopLeftIndex = findIndex(sourceClone, s => s.orderId === stop.orderId && s.type === type);

    if (stopLeftIndex > -1) {
      const destinationIndex = type === "pickup" ? droppableDestination.index : droppableDestination.index + 1;

      const [removedLeft] = sourceClone.splice(stopLeftIndex, 1);
      destClone.splice(destinationIndex, 0, {
        ...removedLeft,
        width: 24,
        marginLeft: 8,
      });
    }

    const newSolutions = { ...solutions };
    newSolutions[droppableSource.droppableId] = sourceClone;
    newSolutions[droppableDestination.droppableId] = destClone;

    setHistory({
      currentIndex: history.currentIndex + 1,
      listSolutions: [...history.listSolutions, newSolutions],
    });

    setSolutions(newSolutions);
    setStepsHovered({});
  };

  const moveSteps = () => {
    const updatedSolutions = { ...solutions };
    let moveIndex = multipleStepState.index;
    let targetDriverId = multipleStepState.toDriverId;
    const sortedAndGroupedData = chain(multipleStepState.steps).sortBy("index").groupBy("driverId").value();

    if (typeof moveIndex !== "number") {
      targetDriverId = targetDriverId === "unscheduled" ? targetDriverId : "assign_" + targetDriverId;
      moveIndex = 0;
    }
    const moveAfterStep = { ...updatedSolutions[targetDriverId][moveIndex] };

    Object.keys(sortedAndGroupedData).forEach(fromDriverId => {
      let sourceClone = [...updatedSolutions[fromDriverId]];

      const stepsToMove = sortedAndGroupedData[fromDriverId];

      sourceClone = sourceClone.filter(step => {
        return !stepsToMove.some(moveStep => step.orderId === moveStep.orderId && step.type === moveStep.type);
      });

      const targetClone = fromDriverId === targetDriverId ? [...sourceClone] : [...updatedSolutions[targetDriverId]];

      moveIndex = targetClone.findIndex(
        step => step.orderId === moveAfterStep.orderId && step.type === moveAfterStep.type,
      );

      stepsToMove.forEach(step => {
        moveIndex++;
        targetClone.splice(moveIndex, 0, {
          ...step,
          width: 24,
          marginLeft: 8,
        });
      });

      updatedSolutions[targetDriverId] = targetClone;

      if (fromDriverId !== targetDriverId) {
        updatedSolutions[fromDriverId] = sourceClone;
      }
    });

    setSolutions(updatedSolutions);
    setStepsHovered({});
    handleCancelMultiStops();

    setHistory({
      currentIndex: history.currentIndex + 1,
      listSolutions: [...history.listSolutions, updatedSolutions],
    });
  };

  const formatSolutions = (ds, stops, hourStart, hourEnd, startTime) => {
    const solutionsTmp = {};
    const formatRoutesT = {};
    let startTimeTmp = startTime;
    let hourStartTmp = hourStart;
    let hourEndTmp = hourEnd;
    let assignedStopIds = [];
    let isSetStartTime = false;

    ds.map(route => {
      let tmpStops = route.steps.filter(s => s.type !== "DRIVER").map(s => ({ ...s, type: s.type.toLowerCase() }));
      // Check startTime on shift time
      const shiftStart = route.shiftStart;
      if (shiftStart) {
        const timeStart = hhMmToHours(shiftStart);
        if (!isSetStartTime) {
          isSetStartTime = true;
          hourStartTmp = timeStart;
          startTimeTmp = `${timeStart}:00`;
        }
        if (timeStart < hourStartTmp) {
          hourStartTmp = timeStart;
          startTimeTmp = `${timeStart}:00`;
        }
      }

      // For handled steps
      const stepOrders = tmpStops.map(s => s.orderId);
      let handledSteps = route.handledSteps ?? [];
      handledSteps = handledSteps.filter(step => {
        return step && !stepOrders.includes(step.orderId);
      });
      const handledOrders = [];
      handledSteps.forEach(step => {
        handledOrders.push(step);

        const stop = stops.find(s => s.orderId === step.orderId);
        // Get hourStart
        if (stop) {
          const completedAt = stop?.completedAt;
          const timeStartStr = moment(completedAt).format("HH:mm");
          const timeStart = hhMmToHours(timeStartStr);
          if (!isSetStartTime) {
            isSetStartTime = true;
            hourStartTmp = timeStart;
            startTimeTmp = `${timeStart}:00`;
          }
          if (timeStart < hourStartTmp) {
            hourStartTmp = timeStart;
            startTimeTmp = `${timeStart}:00`;
          }
        }
      });
      tmpStops = handledOrders.concat(tmpStops);
      tmpStops = calculatePixelBetweenStops(tmpStops, route, oneHourPx);

      solutionsTmp[route.driver._id] = tmpStops;

      const newSummary = {
        distance: round(sumBy(tmpStops, "distance"), 2),
        travelMins: round(sumBy(tmpStops, "travelMins"), 2),
        waitingMins: round(sumBy(tmpStops, "waitingMins"), 2),
        serviceMins: round(sumBy(tmpStops, "duration"), 2),
        workingMins: round(sumBy(tmpStops, "workingMins"), 2),
      };
      formatRoutesT[route.driver._id] = {
        ...route,
        newSteps: tmpStops,
        newSummary,
      };

      solutionsTmp[`assign_${route.driver._id}`] = [];
      assignedStopIds = assignedStopIds.concat(tmpStops.map(s => `${s.orderId}-${s.type.toLowerCase()}`));

      const firstArrivalTime = route.steps[0]?.arrivalTime;
      if (firstArrivalTime) {
        const timeStart = hhMmToHours(firstArrivalTime);
        if (!isSetStartTime) {
          isSetStartTime = true;
          hourStartTmp = timeStart;
          startTimeTmp = `${timeStart}:00`;
        }
        if (timeStart < hourStartTmp) {
          hourStartTmp = timeStart;
          startTimeTmp = `${timeStart}:00`;
        }

        // Get hourEnd
        const arrivalTime = route.steps[route.steps?.length - 1].arrivalTime;
        const timeEnd = hhMmToHours(arrivalTime);

        if (timeEnd > hourEndTmp) {
          hourEndTmp = timeEnd;
        }
      }
      setIsSolution(true);
    });
    setStartTime(startTimeTmp);
    setHourStart(hourStartTmp);
    // Fill full time grant
    if (hourEndTmp - hourStartTmp < 5) {
      hourEndTmp = hourStartTmp + 4;
    }
    setHourEnd(hourEndTmp);

    const unassignedStops = stops.filter(s => !assignedStopIds.includes(s.id));
    solutionsTmp["unscheduled"] = unassignedStops.map((stop, index) => {
      return {
        ...stop,
        color: "#606060",
        index,
      };
    });

    // setHistory({
    //   currentIndex: 0,
    //   listSolutions: [solutionsTmp],
    // });
    if (isOptimize) {
      setHistory({
        currentIndex: history.listSolutions.length,
        listSolutions: [...history.listSolutions, solutionsTmp],
      });
      setIndexFormat(history.listSolutions.length);
      setIsOptimize(false);
    } else {
      setHistory({
        currentIndex: history?.currentIndex || 0,
        listSolutions: [...history.listSolutions.slice(0, -1), solutionsTmp],
      });
      setIndexFormat(history?.currentIndex);
    }

    setSolutions(solutionsTmp);
    setFormatRoutes(formatRoutesT);
  };

  const handleCloseStepPopup = () => {
    if (!clicked) {
      onClosePopup();
      // setStepsHovered({});
    }
  };

  const onDragStart = () => {
    setIsDragging(true);
    setStepsHovered({});
  };

  const moveToUnscheduled = (route, indexSteps) => {
    moveStep({ droppableId: route.driver._id, index: indexSteps }, { droppableId: "unscheduled" });
  };

  const handleClickHistory = action => {
    const { active, pointToVersion } = getActiveAction(action, history);
    if (active) {
      const solutionsTmp = history.listSolutions[pointToVersion];
      setSolutions(solutionsTmp);
      if (action === "revert") {
        setHistory({
          currentIndex: pointToVersion,
          listSolutions: [...history.listSolutions],
        });
      } else {
        setHistory({
          ...history,
          currentIndex: pointToVersion,
        });
      }
    }
  };

  const onClickSwap = route => {
    if (isLive) return;
    const searchedRoutes = routes.filter(item => item.driver._id !== route.driver._id);
    setState({
      ...state,
      visibleModal: true,
      searchedRoutes: searchedRoutes,
      swapFromRoute: route,
      swapToRoute: {},
    });
  };

  const onClickSync = route => {
    if (isLive) return;
    const newSolutions = cloneDeep(solutions);
    const steps = newSolutions[route.driver._id];
    newSolutions[route.driver._id] = steps.reverse();
    setSolutions(newSolutions);
    setHistory({
      currentIndex: history.listSolutions.length,
      listSolutions: [...history.listSolutions, newSolutions],
    });
  };

  const handleOk = () => {
    // const sourceClone = [
    //   ...solutions[`assign_${state.swapFromRoute.driver._id}`],
    //   ...solutions[state.swapFromRoute.driver._id],
    // ];
    // const destClone = [
    //   ...solutions[`assign_${state.swapToRoute.driver._id}`],
    //   ...solutions[state.swapToRoute.driver._id],
    // ];
    // const newSolutions = { ...solutions };
    // newSolutions[`assign_${state.swapFromRoute.driver._id}`] = destClone;
    // newSolutions[`assign_${state.swapToRoute.driver._id}`] = sourceClone;
    // newSolutions[state.swapFromRoute.driver._id] = [];
    // newSolutions[state.swapToRoute.driver._id] = [];
    //
    // setState({
    //   ...state,
    //   visibleModal: false,
    // });
    //
    // setHistory({
    //   currentIndex: history.currentIndex + 1,
    //   listSolutions: [...history.listSolutions, newSolutions],
    // });
    //
    // setSolutions(newSolutions);
    // setStepsHovered({});

    if (isGmpro) return;

    dispatch(
      doSwapOrdersToDriver({
        id: routePlan._id,
        fromDriverId: state.swapFromRoute.driver._id,
        driverId: state.swapToRoute.driver._id,
      }),
    );
    setState({ ...state, visibleModal: false });
  };

  const handleCancel = () => {
    setState({ ...state, visibleModal: false });
  };

  const handleCancelMultiStops = () => {
    setMultipleStepState(initMultipleSteps);
  };

  const onSeachDrivers = e => {
    const searchedRoutes = routes.filter(route => {
      return (
        route.driver._id !== state.swapFromRoute.driver._id &&
        route.driver.name.toLowerCase().includes(e.target.value.toLowerCase())
      );
    });
    setState({ ...state, searchedRoutes });
  };

  const onChangeLive = () => {
    const value = !isLive;
    dispatch(doUpdateIsLive({ id: routePlan._id, isLive: value }));
    setIsLive(value);
  };

  const handleSelectedRoute = route => {
    setState({ ...state, swapToRoute: route });
  };

  const handleOkUpdate = () => {
    dispatch(doDetailRoutePlan(routePlan._id));
    setIsModalVisible(false);
  };

  if (!routes.length) return <></>;
  if (!isSolution) return <></>;

  const hours = range(hourStart, hourEnd + 1);
  const minutes = range(0, (hourEnd - hourStart) * 2 + 3);

  const disabledNextButton =
    history?.listSolutions?.length === 0 || history?.listSolutions?.length === history?.currentIndex + 1;
  const disabledPreviousButton = history?.currentIndex === 0;

  const countAllOrders = routePlan.orders.length;
  const missed = routePlan.orders.filter(o => o.status === "UNSCHEDULED").length;
  const completed = routePlan.orders.filter(o => o.status === "COMPLETED" || o.status === "SKIPPED").length;
  const scheduled = countAllOrders - missed - completed;

  const formatRoutesValues = values(formatRoutes);
  const travelMins =
    round(
      sumBy(formatRoutesValues, r => r.newSummary.travelMins),
      2,
    ) || "-";
  const serviceMins =
    round(
      sumBy(formatRoutesValues, r => r.newSummary.serviceMins),
      2,
    ) || "-";
  const waitingMins =
    round(
      sumBy(formatRoutesValues, r => r.newSummary.waitingMins),
      2,
    ) || "-";
  const workingMins =
    round(
      sumBy(formatRoutesValues, r => r.newSummary.workingMins),
      2,
    ) || "-";
  const distance = round(sumBy(formatRoutesValues, r => r.newSummary.distance) / 1000, 2) || "-";
  const workingPercentage = (routePlan.report?.workingPercentage != 0 && routePlan.report?.workingPercentage) || "-";

  const SummaryNumber = (label, value, end = "") => {
    return (
      <div className="info-item">
        <div className="item-value">
          {value}
          {end}
        </div>
        <div className="item-label">{label}</div>
      </div>
    );
  };

  const handleDownloadSolution = async () => {
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const solutionData = [];
    forEach(routes, route => {
      const steps = formatRoutes[route.driver._id].newSteps;
      forEach(steps, (step, index) => {
        const stop = find(stops, stop => stop.orderId === step.orderId && stop.type === step.type.toLowerCase());
        if (stop) {
          const record = { ...omit(stop, "id"), order: index };

          // Add custom fields
          if (stop.customFields) {
            delete record.customFields;
            record.customFields = JSON.stringify(stop.customFields);
            for (const property in stop.customFields) {
              record[property] = stop.customFields[property];
            }
          }

          // Skipped notes
          if (stop.skipNotes) {
            record["skipNotes"] = stop.skipNotes;
          }

          solutionData.push({
            driverName: record.driverName,
            ...omit(record, "driverName"),
          });
        }
      });
    });
    const wsSolution = XLSX.utils.json_to_sheet(solutionData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsSolution, "Solution");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(dataBlob, `${routePlan.name.replace(/\s+/g, "-")}-solution-${Date.now()}` + fileExtension);
  };

  const handleDownloadSummary = async () => {
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const summaryData = [];
    forEach(routes, route => {
      const newSteps = formatRoutes[route.driver._id].newSteps;
      const newSummary = formatRoutes[route.driver._id].newSummary;
      summaryData.push({
        driverName: route.driver.name,
        distance: newSummary.distance,
        travelMins: newSummary.travelMins,
        waitingMins: newSummary.waitingMins,
        serviceMins: newSummary.serviceMins,
        workingMins: newSummary.workingMins,
        workingPercentage: route.summary?.workingPercentage,
        visits: newSteps.length,
      });
    });
    const wsSummary = XLSX.utils.json_to_sheet(summaryData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, wsSummary, "Summary");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(dataBlob, `${routePlan.name.replace(/\s+/g, "-")}-summary-${Date.now()}` + fileExtension);
  };

  const handleDownloadLabel = async () => {
    try {
      const { response: token } = await doGetTokenRoutePlanLabel({
        id: routePlan._id,
      });
      console.log({ token });
      if (!token) {
        return;
      }
      window.open(
        `${process.env.REACT_APP_API_URI}/route-plans/${routePlan._id}/pdf-generate-label/${token}`,
        "_blank",
      );
    } catch (error) {
      console.error("Error downloading the ZIP file:", error);
    }
  };

  return (
    <div className={`route-chart-content ${expand && "expand"}`} ref={chartRef}>
      <div className="header">
        <div className="left">
          <Button className="btn-timeline active" onClick={() => setChartType("timeline")}>
            {getTranslation(setting, "Route Plans", "Timeline")}
            <ReactSVG className="icon" src="/icons/timeline.svg" />
          </Button>
          {canEdit && (
            <Button className="btn-dispatch" onClick={() => setChartType("dispatch")}>
              {getTranslation(setting, "Route Plans", "Dispatch")}
              <ReactSVG className="icon" src="/icons/dispatch.svg" />
            </Button>
          )}
        </div>
        {canEdit && (
          <div className="right">
            {oneHourPx !== defaultOneHourPx && (
              <>
                <Button type="link" onClick={handleReset}>
                  Reset
                </Button>
                <Button type="link" onClick={handleSaveZoom}>
                  Save
                </Button>
              </>
            )}
            <Button onClick={handleZoomOut}>
              <ZoomOutOutlined />
            </Button>
            <Button onClick={handleZoomIn}>
              <ZoomInOutlined />
            </Button>
            <Button className="btn-force" onClick={handleOptimizeForce} disabled={isLive}>
              {getTranslation(setting, "Route Plans", "Force Schedule All")}
              <ReactSVG className="icon" src="/icons/force.svg" />
            </Button>
            <Popover
              trigger="click"
              content={
                <div className="popover-summary-content">
                  <div className="info">
                    <div className="info-item">
                      <div className="item-value">
                        {completed}/{countAllOrders}
                      </div>
                      <div className="item-label">{getTranslation(setting, "Route Plans", "Completed")}</div>
                    </div>
                    <div className="info-item">
                      <div className="item-value">
                        {missed}/{countAllOrders}
                      </div>
                      <div className="item-label">{getTranslation(setting, "Route Plans", "Missed")}</div>
                    </div>
                    <div className="info-item">
                      <div className="item-value">
                        {scheduled}/{countAllOrders}
                      </div>
                      <div className="item-label">{getTranslation(setting, "Route Plans", "Scheduled")}</div>
                    </div>
                    {SummaryNumber(getTranslation(setting, "Route Plans", "Travel"), convertMinutesToTime(travelMins))}
                    {SummaryNumber(
                      getTranslation(setting, "Route Plans", "Service"),
                      convertMinutesToTime(serviceMins),
                    )}
                    {SummaryNumber(
                      getTranslation(setting, "Route Plans", "Waiting"),
                      convertMinutesToTime(waitingMins),
                    )}
                    {SummaryNumber(
                      getTranslation(setting, "Route Plans", "Working"),
                      convertMinutesToTime(workingMins),
                    )}
                    {SummaryNumber(getTranslation(setting, "Route Plans", "Working %"), workingPercentage, "%")}
                    {SummaryNumber("Km", distance)}
                  </div>
                  <Button className="btn-download" onClick={handleDownloadSolution}>
                    {getTranslation(setting, "Route Plans", "Download Solution")}
                    <ReactSVG className="icon" src="/icons/download.svg" />
                  </Button>
                  <Button className="btn-download" onClick={handleDownloadSummary} style={{ marginTop: "6px" }}>
                    {getTranslation(setting, "Route Plans", "Download Summary")}
                    <ReactSVG className="icon" src="/icons/download.svg" />
                  </Button>

                  <Button className="btn-download" onClick={handleDownloadLabel} style={{ marginTop: "6px" }}>
                    {getTranslation(setting, "Route Plans", "Download Labels")}
                    <ReactSVG className="icon" src="/icons/download.svg" />
                  </Button>
                </div>
              }>
              <Button className="btn-summary">
                {getTranslation(setting, "Route Plans", "Summary")}
                <ReactSVG className="icon" src="/icons/summary.svg" />
              </Button>
            </Popover>
            <Button
              className="btn-expand"
              onClick={() => setExpand(!expand)}
              icon={expand ? <DownOutlined /> : <UpOutlined />}
              size="small"></Button>
          </div>
        )}
      </div>
      <div className="content">
        <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
          {canEdit && (
            <>
              <div className={`plan-live ${isLive ? "live" : "plan"}`}>
                <div className="left">
                  <b>{isLive ? "Live" : "Plan"}</b>
                </div>
                <div className="right">
                  <p className="text-plan">Plan</p>
                  <Switch className="custom" checked={isLive} onChange={onChangeLive} />
                  <p className="text-live">Live</p>
                </div>
              </div>
              <div className="tbody unscheduled">
                <UnScheduled
                  steps={solutions["unscheduled"]}
                  stepsHovered={stepsHovered}
                  setStepsHovered={setStepsHovered}
                  onClickStep={onClickStep}
                  onHoverStep={onHoverStep}
                  handleCloseStepPopup={handleCloseStepPopup}
                  isDragging={isDragging}
                  driverIdsHide={driverIdsHide}
                  onClickHide={onClickHide}
                  actionDnd={actionDnd}
                  isLive={isLive}
                  selectedMultipleSteps={selectedMultipleSteps}
                  setAllInclusiveMultipleSteps={setAllInclusiveMultipleSteps}
                  multipleStepState={multipleStepState}
                />
              </div>
            </>
          )}
          <div className="scrollCustom tbody" ref={containerTimelineRef}>
            <DriverTime
              hours={hours}
              nonTimeRef={nonTimeRef}
              driverIdsLock={driverIdsLock}
              driverIdsHide={driverIdsHide}
              onClickLock={onClickLock}
              onClickHide={onClickHide}
              setting={setting}
              oneHourPx={oneHourPx}
              stateTimeLine={stateTimeLine}
              timeLineRef={timeLineRef}
              clickTimeLine={clickTimeLine}
            />
            <DriverList
              routes={routes}
              solutions={solutions}
              originSolutions={history.listSolutions[indexFormat]}
              hours={hours}
              minutes={minutes}
              startTime={startTime}
              onClickStep={onClickStep}
              onClickRoute={handleOnClickRoute}
              onClickSwap={onClickSwap}
              onClickSync={onClickSync}
              handleCloseStepPopup={handleCloseStepPopup}
              moveToUnscheduled={moveToUnscheduled}
              stopsHash={stopsHash}
              stepsHovered={stepsHovered}
              setStepsHovered={setStepsHovered}
              onHoverStep={onHoverStep}
              onHoverRoute={handleOnHoverRoute}
              isDragging={isDragging}
              driverIdsLock={driverIdsLock}
              driverIdsHide={driverIdsHide}
              onClickLock={onClickLock}
              onClickHide={onClickHide}
              actionDnd={actionDnd}
              routeType={routeType}
              setShowMoreRoute={setShowMoreRoute}
              oneHourPx={oneHourPx}
              isLive={isLive}
              selectedMultipleSteps={selectedMultipleSteps}
              setAllInclusiveMultipleSteps={setAllInclusiveMultipleSteps}
              multipleStepState={multipleStepState}
              stepClicked={stepClicked}
              isGmpro={isGmpro}
            />
          </div>
        </DragDropContext>
      </div>
      {canEdit && (
        <div className="footer">
          <div className="left">
            <Button
              size="large"
              className="btn-undo"
              onClick={() => handleClickHistory("undo")}
              disabled={disabledPreviousButton}>
              {getTranslation(setting, "Route Plans", "Undo")}
              <ReactSVG className="icon" src="/icons/undo.svg" />
            </Button>
            <Button
              size="large"
              className="btn-redo"
              onClick={() => handleClickHistory("redo")}
              disabled={disabledNextButton}
              style={{ display: "none" }}>
              {getTranslation(setting, "Route Plans", "Redo")}
              <ReactSVG className="icon" src="/icons/redo.svg" />
            </Button>
            <Button
              size="large"
              className="btn-revert"
              onClick={() => handleClickHistory("revert")}
              disabled={disabledPreviousButton}>
              {getTranslation(setting, "Route Plans", "Revert")}
              <ReactSVG className="icon" src="/icons/restore.svg" />
            </Button>
          </div>
          <div className="right">
            {/* <Button
              size="large"
              className="btn-optimize-route"
              onClick={handleReorder}
              disabled={actionDnd !== "sort" || isLive}
            >
              {getTranslation(setting, "Route Plans", "Apply")}
              <ReactSVG className="icon" src="/icons/optimize-route.svg" />
            </Button> */}
            <Button
              size="large"
              className="btn-optimize-route"
              onClick={handleOptimize}
              disabled={actionDnd === "sort" || isLive}>
              {getTranslation(setting, "Route Plans", "Optimize Route")}
              <ReactSVG className="icon" src="/icons/optimize-route.svg" />
            </Button>
            <Button size="large" className="btn-dispatch-route" onClick={handleDispatch} disabled={isLive}>
              {routePlan.status === "DISPATCHED" && getTranslation(setting, "Route Plans", "Dispatch Update")}
              {routePlan.status !== "DISPATCHED" && getTranslation(setting, "Route Plans", "Dispatch to Drivers")}
              <ReactSVG className="icon" src="/icons/dispatch-to-driver.svg" />
            </Button>
          </div>
        </div>
      )}
      <SwapDriver
        state={state}
        handleOk={handleOk}
        handleCancel={handleCancel}
        handleSelectedRoute={handleSelectedRoute}
        onSeachDrivers={onSeachDrivers}
      />
      <SwapStopsToDriver
        state={multipleStepState}
        setMultipleStepState={setMultipleStepState}
        handleOk={moveSteps}
        handleCancel={handleCancelMultiStops}
        routes={routes}
        solutions={solutions}
        actionDnd={actionDnd}
        orders={routePlan?.orders || []}
      />
      <Modal
        title={getTranslation(setting, "Route Plans", "Order Status Update")}
        open={isModalVisible}
        onOk={handleOkUpdate}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalVisible(false)}>
            {getTranslation(setting, "Route Plans", "Do not refresh")}
          </Button>,
          <Button key="submit" type="primary" onClick={handleOkUpdate}>
            {getTranslation(setting, "Route Plans", "Refresh")}
          </Button>,
        ]}
        width={370}
        className="notify-modal">
        <p>
          {orderMess}.{" "}
          {getTranslation(
            setting,
            "Route Plans",
            "Would you like to refresh? (You will lose any changes since the last optimization.)",
          )}
        </p>
      </Modal>
    </div>
  );
};

export default RouteChart;
